<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createProposal.riskDescriptionQuestion'|translate}}</h3>
    </div>

    <div *ngIf="requiresExcelUpload" class="d-flex flex-column mb-3">
      <span class="cursor-pointer mb-2">{{'createProposal.excelTemplateInstruction'|translate}}</span>
      <button type="button"
              class="d-flex tile-button cursor-pointer blue-content align-self-end"
              style="white-space: nowrap; padding: 0.375rem 0.75rem;"
              (click)="fileUploadService.downloadExcelTemplate()">
        {{'createProposal.downloadExcelTemplate'|translate}}
        <mat-icon>file_download</mat-icon>
      </button>
    </div>

    <app-input-field [control]="formGroup.controls.riskDescriptionFreeText" class="field-container"
                     [label]="'createProposal.description'|translate">
      <textarea formControlName="riskDescriptionFreeText"
                class="input input-text-area" cdkTextareaAutosize
                [cdkAutosizeMinRows]="3"
                placeholder="{{'createProposal.riskDescriptionPlaceholder' | translate}}"> </textarea>
    </app-input-field>
  </div>

  <div class="d-flex flex-column">
    <span
      class="small-title"> {{'proposalDetails.createOfferTab.fileUploadSection.title'|translate}}</span>
    <div class="d-flex field-container mb-0">
      <app-upload
        [uploadLocation]="UploadLocation.RISKDESCRIPTION"
        [hasError]="requiresExcelUpload
                    && !hasRiskLocationInputValue
                    && !!formGroup.controls.riskDescriptionFiles.errors?.['excelRequired']
                    && (formGroup.controls.riskDescriptionFiles.touched
                        || formGroup.controls.riskDescriptionFiles.dirty)"
        (updateAttachedFilesInParent)="attachFiles($event)"
        class="w-100"
      ></app-upload>
    </div>
    <div *ngIf="requiresExcelUpload
                && !hasRiskLocationInputValue
                && formGroup.controls.riskDescriptionFiles.errors?.['excelRequired']
                && (formGroup.controls.riskDescriptionFiles.touched || formGroup.controls.riskDescriptionFiles.dirty)"
         class="error-label">
      <img class="mr-1" src="assets/img/form/error.svg" alt="">
      {{'createProposal.excelTemplateRequired'|translate}}
    </div>
  </div>
</form>
